export default {
  langName: "Español",
  common: {
    company: "Una empresa de Eagle Inc",
    privacy: "Privacidad",
    terms: "Términos de uso",
    support: "Soporte",
  },
  nav: {
    group: "Eagle Eyes Group",
    realEstate: "Real Estate",
    itManagement: "IT Management",
    digitalServices: "Digital Services",
    backToGroup: "Eagle Eyes Group",
    property: "Property",
    investment: "Investment",
  },
  form: {
    name: "Nombre completo",
    email: "Dirección de email",
    sending: "Enviando…",
    sent: "Gracias — hemos recibido tus datos. Te contactaremos en breve.",
    error: "Algo salió mal. Inténtalo de nuevo o escríbenos directamente.",
  },
  gateway: {
    hero1: "EAGLE",
    hero2: "EYES",
    hero3: "GROUP",
    chapters: [
      { num: "01", name: "Real Estate", sub: "Property · Investment — Tirana", desc: "Viviendas de alquiler cuidadas con esmero y un enfoque verificable y disciplinado de la inversión inmobiliaria residencial.", cta: "Entrar en Real Estate" },
      { num: "02", name: "IT Management", sub: "Consultoría & servicios gestionados", desc: "Consultoría IT senior en cloud, identidad, seguridad y DevOps — definida con precisión, entregada personalmente, gestionada a largo plazo.", cta: "Entrar en IT Management" },
      { num: "03", name: "Digital Services", sub: "Productos que construimos y operamos", desc: "Un portfolio creciente de productos web y móviles en social commerce, marketing y reservas — diseñados y operados internamente.", cta: "Entrar en Digital Services" },
    ],
    footerBrand: "Eagle Eyes Group",
  },
  re: {
    forClients: "Para clientes",
    propertyH: "Property",
    propertyP: "Viviendas de alquiler en el centro de Tirana, encontradas y cuidadas con esmero. Para quienes buscan un lugar donde vivir, no una transacción.",
    propertyCta: "Entrar en Eagle Eyes Property",
    forInvestors: "Para inversores",
    investmentH: "Investment",
    investmentP: "Un enfoque verificable y disciplinado del residencial de Tirana. Para quienes quieren ver exactamente lo que respaldan.",
    investmentCta: "Entrar en Eagle Eyes Investment",
  },
  property: {
    kicker: "Eagle Eyes Property",
    h1: "Un hogar en Tirana, cuidado desde el principio.",
    intro: "Encontramos, preparamos y gestionamos apartamentos de alquiler en el centro de Tirana — para inquilinos que quieren un hogar bien gestionado, no solo un anuncio.",
    cta: "Únete a la lista de espera",
    navWhat: "Qué hacemos",
    navHow: "Cómo funciona",
    navJoin: "Únete a la lista",
    whatTitle: "Qué hace Eagle Eyes Property",
    whatMeta: "Incorporación en curso · Anuncios próximamente",
    what: [
      { label: "Selección", title: "Apartamentos seleccionados", text: "Cada vivienda se elige e inspecciona en barrios céntricos de Tirana — nada de buscar entre anuncios que no resisten una visita en persona." },
      { label: "Gestión", title: "Un único punto de contacto", text: "Mantenimiento, documentos y preguntas pasan por un solo equipo, no por un propietario difícil de localizar." },
      { label: "Transparencia", title: "Condiciones claras, desde el inicio", text: "Precios, contratos y depósitos explicados con claridad antes de comprometerte — sin sorpresas después de la mudanza." },
    ],
    howTitle: "Cómo funciona",
    howMeta: "Tres pasos",
    steps: [
      { title: "Cuéntanos qué buscas", text: "Presupuesto, barrio, tamaño, fecha de entrada — lo básico que realmente acota la búsqueda." },
      { title: "Te emparejamos con viviendas disponibles", text: "Tendrás noticias nuestras cuando tengamos apartamentos adecuados, no un aluvión de opciones equivocadas." },
      { title: "Múdate, con soporte después", text: "Firmado, instalado, atendido — Eagle Eyes sigue siendo tu punto de contacto mientras alquiles con nosotros." },
    ],
    waitTitle: "Sé el primero en ver los apartamentos",
    waitText: "Eagle Eyes Property está incorporando sus primeras viviendas en el centro de Tirana. Deja tus datos y te avisaremos en cuanto se abran los anuncios.",
    neighbourhood: "Barrio preferido (opcional)",
    waitButton: "Únete a la lista de espera",
    waitNote: "Sin spam — solo un mensaje cuando los apartamentos estén disponibles.",
    footerBrand: "Eagle Eyes Property",
  },
  investment: {
    kicker: "Eagle Eyes Investment",
    h1: "Residencial en Tirana, construido para ser verificado.",
    intro: "Eagle Eyes compra y alquila apartamentos en el centro de Tirana a través de una holding albanesa estructurada — gestionada para que cada afirmación pueda verificarse, no solo creerse.",
    cta: "Solicita el paquete informativo",
    navThesis: "Cómo está construido",
    navTrack: "Track record",
    navContact: "Contacto",
    thesisTitle: "Cómo está construida Eagle Eyes",
    thesisP1: "Adquirimos apartamentos en barrios céntricos de Tirana, los alquilamos a inquilinos seleccionados a través de Eagle Eyes Property y los mantenemos en una estructura societaria dedicada — separando propiedad, gestión y rendición de cuentas para que cada una pueda examinarse por separado.",
    thesisP2: "El objetivo es un portfolio que crece con deliberación: menos adquisiciones, cada una documentada lo bastante bien como para que un inversor pueda reconstruir nuestro razonamiento sin tener que fiarse de nuestra palabra.",
    specs: [
      { k: "Propiedad", v: "Holding albanesa / estructura SPV" },
      { k: "Operaciones", v: "Gestionadas vía Eagle Eyes Property" },
      { k: "Enfoque", v: "Apartamentos residenciales en el centro de Tirana" },
      { k: "Rendición", v: "Documentación disponible bajo petición" },
    ],
    trackTitle: "Track record",
    trackMeta: "Primeras adquisiciones en curso",
    trackBoxTitle: "Resultados objeto a objeto — próximamente",
    trackBoxText: "A medida que los apartamentos se adquieran, alquilen y (cuando proceda) se vendan, cada uno aparecerá aquí con las cifras que lo respaldan — coste de adquisición, obras, ocupación y rentabilidad.",
    trackBoxNote: "¿Quieres el estado actual antes de la publicación? Pregunta abajo.",
    verifyTitle: "Qué pueden revisar los inversores verificados",
    verify: [
      { label: "Entidad", title: "Estructura societaria", text: "Documentos de registro de la holding y la SPV, y cómo se sitúa la propiedad de cada apartamento por debajo de ellas." },
      { label: "Activos", title: "Detalle por inmueble", text: "Ubicación, estado, condiciones de adquisición y situación de alquiler de cada apartamento en cartera o en oferta." },
      { label: "Finanzas", title: "Las cifras subyacentes", text: "Costes, condiciones de financiación e ingresos por alquiler del portfolio — compartidos directamente, no resumidos." },
      { label: "Personas", title: "Quién está detrás", text: "Trayectoria de quien dirige Eagle Eyes y cómo se relacionan las áreas de Property e Investment." },
    ],
    contactTitle: "Pide ver el detalle",
    contactText: "Dinos quién eres y qué te gustaría verificar. Te responderemos directamente con la documentación pertinente.",
    roleLabel: "Te presentas como…",
    roles: ["Un inversor potencial", "Un inversor existente", "Otro / asesor"],
    verifyField: "¿Qué te gustaría verificar? (opcional)",
    contactButton: "Solicitar información",
    contactNote: "La documentación se comparte directamente con personas concretas, no se publica abiertamente.",
    footerBrand: "Eagle Eyes Investment",
  },
  it: {
    kicker: "IT Management",
    h1a: "Eagle Eyes",
    h1b: "IT Management",
    hero: "Consultoría IT integral adaptada a tus necesidades: desde soluciones específicas de alcance único y estrategias integrales hasta la gestión del portfolio a largo plazo y el mantenimiento continuo",
    heroCta: "Inicia una conversación",
    navProcess: "Cómo trabajamos",
    navExpertise: "Competencias",
    navEngagements: "Proyectos",
    profileTitle: "Perfil",
    profile: "Eagle Eyes IT Management es una firma de gestión y consultoría que atiende a clientes en todo el mundo. Nuestros consultores acompañan directamente a cada cliente desde la primera reunión hasta la entrega final — endpoint, identidad, gestión de dispositivos, seguridad y cloud hosting en Azure y Microsoft 365 — y siguen siendo responsables del portfolio durante toda la vigencia del contrato.",
    processTitle: "Cómo trabajamos",
    process: [
      { num: "01", title: "Scope first", text: "Cada encargo parte de tu solicitud, de reuniones de profundización y de un scope escrito: entregables, criterios de aceptación, nada ambiguo." },
      { num: "02", title: "Discovery", text: "Un análisis detallado sobre horas de consultoría acordadas, facturadas por adelantado, que concluye con una propuesta totalmente costeada." },
      { num: "03", title: "Contratación", text: "Servicios puntuales facturados por adelantado. Trabajo continuado adaptado a tu organización. Gestión del portfolio y mantenimiento con contratos anuales y facturación mensual. Combinaciones negociables." },
    ],
    expertiseTitle: "Competencias",
    expertise: [
      { title: "Modern workplace", items: "Windows 11 · Intune · Autopilot" },
      { title: "Microsoft 365", items: "Exchange · SharePoint · Teams · Migraciones" },
      { title: "Seguridad", items: "Defender · Hardening · Secrets · Patching" },
      { title: "Service management", items: "Jira · JSM · Confluence · Diseño de procesos" },
      { title: "Identity & access", items: "Entra ID · Conditional access · MFA · SSO" },
      { title: "Azure & hosting", items: "IaaS / PaaS · Networking · Dominios · SSL" },
      { title: "DevOps & CI/CD", items: "Azure DevOps · Bitbucket · Pipelines" },
      { title: "IT management", items: "Diseño de servicios · Proveedores · Presupuestos" },
    ],
    engagementsTitle: "Proyectos seleccionados a largo plazo",
    engagements: [
      { client: "Proveedor multinacional de software lingüístico", role: "IT Business Consultancy & Global DevOps Management", text: "Constitución de la filial nacional más reciente y diseño de la arquitectura IT global de la corporación. Este proyecto implicó escalar las operaciones locales de 5 a 60 profesionales en 18 meses, construyendo y liderando al mismo tiempo los equipos multifuncionales de DevOps y gestión IT que impulsan la infraestructura de las oficinas globales." },
      { client: "Autoridad global en ingeniería de software", role: "IT Cloud & DevOps Consultancy", text: "Estructuración y optimización de la infraestructura IT corporativa para un líder mundialmente reconocido en desarrollo de software. Este proyecto implicó construir desde cero un ecosistema DevOps de alto rendimiento y diseñar una infraestructura de datacenter híbrida que da soporte a más de 500 usuarios internos." },
      { client: "Proveedor nacional de servicios empresariales", role: "IT Cloud Consultancy & VoIP Architecture", text: "Consultoría técnica integrada e in-house para clientes B2B de primer nivel y proveedores de servicios. El foco principal: diseño y despliegue de arquitecturas VoIP altamente escalables y soluciones cloud de nivel empresarial." },
    ],
    contactTitle: "Inicia una conversación",
    contactText: "Cuéntanos tu entorno y qué quieres lograr. Respondemos personalmente — normalmente en un día laborable.",
    companyField: "Empresa (opcional)",
    messageField: "¿Cómo podemos ayudarte?",
    contactButton: "Enviar solicitud",
    contactBlockTitle: "Contacto",
    servicesTitle: "Servicios & Competencias",
    productsTitle: "Productos & Marcas",
    portfolioTitle: "Gestión del Portfolio",
    services: ["Modern workplace", "Microsoft 365", "Seguridad", "Service management", "Identity & access", "Azure & hosting", "DevOps & CI/CD", "IT management"],
    products: ["Microsoft 365", "Azure", "Entra ID", "Intune", "PowerShell", "Azure DevOps", "Bitbucket", "Postman", "Jira", "Jira Service Management", "Confluence", "Twilio", "Agora"],
    portfolio: ["Diseño de servicios", "Gestión de proveedores", "Responsabilidad de presupuesto", "Mantenimiento & soporte", "Contratación anual", "Facturación mensual"],
    footerBrand: "Eagle Eyes IT Management",
  },
  digital: {
    kicker: "Eagle Eyes Digital Services",
    h1: "Productos que construimos, operamos y hacemos crecer.",
    intro: "Digital Services es el estudio de producto de Eagle Eyes: diseñamos, lanzamos y operamos nuestros propios productos web y móviles en social commerce, marketing y reservas.",
    navPortfolio: "El portfolio",
    navDeals: "Ofertas & Marketing",
    navContact: "Contacto",
    appsTitle: "El portfolio",
    live: "Live",
    soon: "Próximamente",
    capsTitle: "Qué construimos",
    caps: [
      { title: "Social commerce", text: "Convertir audiencias en clientes con picks y ofertas comprables." },
      { title: "Campañas & ofertas", text: "Promociones limitadas en el tiempo pensadas para compartir y convertir rápido." },
      { title: "Reservas & agenda", text: "Citas, disponibilidad y recordatorios sin fricción." },
      { title: "Analítica & insights", text: "Cada producto medido desde el primer clic hasta el cliente recurrente." },
    ],
    studioTitle: "Un estudio de producto interno",
    studioText: "Digital Services diseña, construye y opera los productos de Eagle Eyes de principio a fin — del primer boceto a la infraestructura, el soporte y el crecimiento. Sin trabajo para clientes, sin agencias: nuestros productos, nuestro estándar.",
    statProducts: "Productos",
    statLive: "Live",
    statLaunching: "En lanzamiento",
    apps: [
      { name: "Socialdeal", tag: "Ofertas & marketing", status: "live", desc: "Socialdeal ofrece a los negocios locales una forma rápida de publicar ofertas y campañas por tiempo limitado, pensada para compartir en social y convertir directamente.", url: "https://www.socialdeal.al/", cta: "Visitar Socialdeal", features: ["Publicación de ofertas por tiempo limitado", "Pensado para compartir en social", "Flujos de conversión directa"] },
      { name: "BookItNow", tag: "Plataforma de reservas", status: "soon", desc: "BookItNow es nuestro producto más reciente: reservas online simples y rápidas para negocios de servicios — citas, disponibilidad y recordatorios en un solo lugar.", url: "", cta: "Próximamente", features: ["Reserva de citas online", "Disponibilidad en vivo", "Recordatorios automáticos"] },
      { name: "InContact", tag: "Telefonía SIP & PBX", status: "soon", desc: "InContact es nuestro sistema SIP y PBX: telefonía en la nube con números de empresa, enrutamiento de llamadas y colas — gestionado online, sin hardware en las oficinas.", url: "", cta: "Próximamente", features: ["Troncales SIP y PBX alojada", "Enrutamiento y grupos de llamada", "Números y buzón online"] },
    ],
    contactTitle: "Trabaja con nosotros",
    contactText: "¿Interesado en un producto, una alianza o un piloto? Deja un mensaje y te responderemos.",
    messageField: "Tu mensaje",
    contactButton: "Enviar mensaje",
    footerBrand: "Eagle Eyes Digital Services",
  },
  inc: {
    hero1: "EAGLE",
    hero2: "INC",
    intro: "Una holding, dos grupos — donde el servicio y el desarrollo se unen.",
    eyesBtn: "Eagle Eyes Group",
    eyesSub: "Real Estate · IT Management · Digital Services",
    eyesCta: "Entrar en Eagle Eyes Group",
    commerceBtn: "Eagle Commerce Group",
    commerceSub: "Socialdeal · BookItNow · InContact",
    commerceCta: "Entrar en Eagle Commerce Group",
    footerBrand: "Eagle Inc",
    footerLegal: "Eagle Inc Sh.P.K.",
    tagline: "Sociedad holding",
  },
  commerce: {
    hero1: "EAGLE",
    hero2: "COMMERCE",
    hero3: "GROUP",
    intro: "Eagle Commerce Group diseña, lanza y opera sus propios productos de e-commerce — desde ofertas locales hasta reservas y contacto con clientes.",
    live: "Live",
    soon: "Próximamente",
    visit: "Visitar",
    explore: "Explorar",
    products: [
      { name: "Socialdeal", tag: "Ofertas & marketing", status: "live", desc: "Ofertas locales y campañas de marketing — publicadas rápido, compartidas en social, convertidas directamente.", url: "https://www.socialdeal.al/", brand: "Eagle Commerce Socialdeal", h1: "Ofertas locales, hechas para compartir.", story: "Socialdeal ofrece a los negocios locales una forma rápida y social de publicar ofertas temporales y campañas — pensada para compartir, ajustada a la conversión directa.", points: ["Publicación de ofertas temporales", "Hecho para compartir en social", "Flujos de conversión directa"] },
      { name: "BookItNow", tag: "Plataforma de reservas", status: "soon", desc: "Reservas online simples y rápidas para negocios de servicios — citas, disponibilidad y recordatorios en un solo lugar.", url: "", brand: "Eagle Commerce BookItNow", h1: "Reservar, sin fricción.", story: "BookItNow permite a los negocios de servicios aceptar citas online en minutos — disponibilidad en vivo, recordatorios automáticos y un flujo de reserva que los clientes realmente completan.", points: ["Reserva de citas online", "Disponibilidad en vivo", "Recordatorios automáticos"] },
      { name: "InContact", tag: "Telefonía SIP & PBX", status: "soon", desc: "Telefonía en la nube para empresas: troncales SIP, PBX alojada y cada número en un solo lugar.", url: "", brand: "Eagle Commerce InContact", h1: "Telefonía de empresa, sin hardware.", story: "InContact es una plataforma SIP y PBX completa en la nube: números de empresa, enrutamiento de llamadas, colas y buzón de voz — gestionada online, sin hardware físico.", points: ["Troncales SIP y PBX alojada", "Enrutamiento y colas", "Números gestionados online"] },
    ],
    footerBrand: "Eagle Commerce Group",
  },
};
